// extracted by mini-css-extract-plugin
export default {"PaginationWrapper":"RecipeList_PaginationWrapper__ANblb","RecipeList":"RecipeList_RecipeList__9S8o-","KemuRow":"RecipeList_KemuRow__nDVFU","NoResults":"RecipeList_NoResults__9VyMN"};